import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { useColumnsView } from '../../hooks/useColumnsView.js';

export const useColumnsApi = ({ enabled = true } = {}) => {
  const { viewType, relatedEntityId } = useColumnsView();

  const { data, ...rest } = useQuery({
    ...MediaPlan.getColumnsListByViewQueryOptions({
      urlParams: { viewType, relatedEntityId },
    }),
    enabled: enabled && !!relatedEntityId,
    staleTime: Infinity, // default refetch is not needed, we refetch on socket event
  });
  return { data: data?.data, ...rest };
};
